<template>
  <div class="date-time-picker-wrapper">
    <Datepicker class="custom-datepicker" v-bind="$attrs" v-on="$listeners" />
  </div>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  components: { Datepicker },
};
</script>

<style>
.date-time-picker-wrapper {
  display: inline-flex;
  width: auto;
  max-width: none;
  min-width: 0;
  position: relative;
  overflow: visible;
}

.custom-datepicker,
.custom-datepicker .dp__input_wrap {
  display: inline-flex !important;
  width: min-content !important;
  max-width: none !important;
  min-width: 0 !important;
  position: relative !important;
  overflow: visible !important;
  flex: 0 0 auto !important;
  white-space: nowrap !important;
}

.custom-datepicker .dp__input {
  display: inline-block !important;
  width: min-content !important;
  max-width: none !important;
  padding-right: 2.2rem !important;
  box-sizing: content-box !important;
  white-space: nowrap !important;
}

.custom-datepicker .dp__clear_icon {
  position: absolute !important;
  right: -2rem !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 60 !important;
}
</style>